"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = require("../Model");
var ShipmentOverview = /** @class */ (function () {
    function ShipmentOverview(pageData, page, size, query, filter) {
        if (page === void 0) { page = 1; }
        if (size === void 0) { size = 25; }
        var _this = this;
        this.pageData = pageData;
        this.page = page;
        this.size = size;
        this.query = query;
        this.filter = filter;
        this.next = function () {
            if (_this.query) {
                return ShipmentOverview.searchOverviewShipments(_this.query, _this.page + 1, _this.size, _this.filter);
            }
            return ShipmentOverview.findOverviewShipments(_this.page + 1, _this.size);
        };
        this.previous = function () {
            if (_this.query) {
                return ShipmentOverview.searchOverviewShipments(_this.query, _this.page - 1, _this.size, _this.filter);
            }
            return ShipmentOverview.findOverviewShipments(_this.page - 1, _this.size);
        };
    }
    ShipmentOverview.findOverviewShipments = function (page, size) {
        if (page === void 0) { page = 1; }
        if (size === void 0) { size = 25; }
        return __awaiter(this, void 0, void 0, function () {
            var skip, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        skip = (page - 1) * size;
                        return [4 /*yield*/, Model_1.Model.makeRequest("/delivery/functions/overview-shipments", Model_1.METHOD.GET, {
                                skip: skip,
                                take: size,
                            }, false, undefined, true)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, new ShipmentOverview(data, page, size)];
                }
            });
        });
    };
    ShipmentOverview.searchOverviewShipments = function (query, page, size, filters, fetchAllShipmentIds) {
        if (page === void 0) { page = 1; }
        if (size === void 0) { size = 25; }
        if (filters === void 0) { filters = {}; }
        if (fetchAllShipmentIds === void 0) { fetchAllShipmentIds = false; }
        return __awaiter(this, void 0, void 0, function () {
            var skip, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        skip = (page - 1) * size;
                        return [4 /*yield*/, Model_1.Model.makeRequest(
                            // tslint:disable-next-line:max-line-length
                            "/delivery/functions/overview-shipments", Model_1.METHOD.GET, {
                                take: size,
                                skip: skip,
                                fetchAllShipmentIds: fetchAllShipmentIds,
                                q: query,
                                filters: filters,
                            }, false, undefined, true)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, fetchAllShipmentIds ? data : new ShipmentOverview(data, page, size, query, filters)];
                }
            });
        });
    };
    ShipmentOverview.getOverviewShipment = function (shipmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Model_1.Model.makeRequest("/delivery/functions/overview-shipments", Model_1.METHOD.GET, {
                            filters: {
                                shipment_id: shipmentId,
                            },
                        }, false, undefined, true)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, new ShipmentOverview(data)];
                }
            });
        });
    };
    return ShipmentOverview;
}());
exports.ShipmentOverview = ShipmentOverview;
